module.exports = __webpack_public_path__ + "static/media/customerHeaderImg.6fae389e.png";